/**
 * Removes null attributes from an object.
 * 
 * @param obj - The object to remove null attributes from.
 * @returns The object with null attributes removed.
 */
export const removeNullAttributes = (obj: any): any => {
    Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === '') {
            delete obj[key];
        }
    });
    return obj;
}
